class PaymentAccountForm extends EventEmitter {
  constructor({ accountFormEventEmitter, accountFormValidator, spinner, formMessage, refreshAccounts }) {
    super();
    this.accountFormEventEmitter = accountFormEventEmitter;
    this.accountFormValidator = accountFormValidator;
    this.spinner = spinner;
    this.formMessage = formMessage;
    this.refreshAccounts = refreshAccounts;
  }

  async initialize(token) {
    if (!feature_flags.FEATURE_BUSINESS_NAME) {
      this.showIndividual();
    }

    const done = () => {
      this.accountFormValidator
        .off('success', onSuccess)
        .off('error', onError);
    }

    const onSuccess = async (results) => {
      try {
        await this.refreshAccounts();
        this.accountFormEventEmitter.resetForm();
        this.endSubmit('success', results, done);
      } catch (err) {
        this.endSubmit('error', err, done);
      }
    }

    const onError = (err) => {
      this.endSubmit('error', err, done);
    }

    this.accountFormEventEmitter.on('submit', async () => {
      this.emit('submit');
      this.clearMessage().setSpinnerSpinning(true);

      await this.accountFormValidator
        .on('success', onSuccess)
        .on('error', onError)
        .validate(this.accountFormEventEmitter);
    });

    this.accountFormEventEmitter.initialize(token);
    return this;
  }

  showIndividual() {
    let personalDetails = document.getElementById("personal-account-form-field");
    let businessName = document.getElementById("business-account-form-field");
    let businessAccountButton = document.getElementById("business-account");
    let individualAccountButton = document.getElementById("individual-account");
    personalDetails.style.display = "block";
    personalDetails.children[1].style.marginLeft = "0";
    personalDetails.children[1].style.marginBottom = "1em";
    businessAccountButton.style.display = "none";
    businessName.style.display = "none";
    individualAccountButton.style.display = "none";
  }

  endSubmit(event, message, done) {
    this.setSpinnerSpinning(false);
    done();

    if (event === 'success') {
      return this.setSuccessMessage(message).emit('success', message).emit('done');
    }

    return this.setErrorMessage(message).emit('error', message).emit('done');
  }

  setSpinnerSpinning(spinning) {
    this.spinner.prop('disabled', spinning);

    return this;
  }

  clearMessage() {
    this.formMessage
      .removeClass('form-card-message-success')
      .removeClass('form-card-message-error')
      .empty();

    return this;
  }

  setMessage(messageClass, message) {
    this.formMessage.addClass(messageClass).text(message);
    if (this.accountFormValidator.constructor.name === "GpiBankAccountFormValidator") {
      switch (messageClass) {
        case "form-card-message-error":
          this.formMessage.attr("data-cy", 'bank-account-error-message-text');
          break;
        case "form-card-message-success":
          this.formMessage.attr("data-cy", 'bank-account-success-message-text');
          break;
      }
    }
    if (['GpiCardFormValidator', 'SlidePayCardFormValidator'].includes(this.accountFormValidator.constructor.name)) {
      switch (messageClass) {
        case "form-card-message-error":
          this.formMessage.attr("data-cy", 'credit-card-error-message-text');
          break;
        case "form-card-message-success":
          this.formMessage.attr("data-cy", 'credit-card-success-message-text');
          break;
      }

    }
    return this;
  }

  setErrorMessage(message) {
    return this.setMessage('form-card-message-error', message);
  }

  setSuccessMessage(message) {
    return this.setMessage('form-card-message-success', message);
  }
}

const getInputConfig = (inputType, prop) => {
  return {
    checkbox: {
      inputType: 'checkbox',
      wrapperClass: 'checkbox',
      labelClass: 'checkbox-label',
      autocheck: false
    },
    radio: {
      inputType: 'radio',
      wrapperClass: 'radio-button',
      labelClass: 'radio-button-label',
      autocheck: true
    }
  }[inputType][prop];
}

const createPaymentOptionElement = (name, id, text, inputType, checked) => {
  return $(document.createElement("div"))
    .addClass(getInputConfig(inputType, "wrapperClass"))
    .addClass("payment-option")
    .append(
      $(document.createElement("input"))
        .attr("type", getInputConfig(inputType, "inputType"))
        .attr("name", name)
        .attr("id", id)
        .attr("value", id)
        .attr("checked", checked && getInputConfig(inputType, "autocheck"))
    )
    .append(
      $(document.createElement("label"))
        .addClass(getInputConfig(inputType, "labelClass"))
        .attr("for", id)
        .text(text)
    );
}

const setupNewCardForm = (providerName, refreshAccounts, token) => {
  if (providerName === 'SlidePay') {
    if (!token) {
      return;
    }

    return setupSlidePayCardForm(refreshAccounts, token);
  }

  return setupGPICardForm(refreshAccounts);
}

const createBankAccountElement = (bankAccount, inputType, checked) => {
  return createPaymentOptionElement(
    "bank-accounts",
    bankAccount.token,
    `${bankAccount.accountType} account ending in ${bankAccount.last4}`,
    inputType,
    checked
  );
}

const createCreditCardElement = (card, inputType, checked) => {
  return createPaymentOptionElement(
    "credit-cards",
    card.token,
    `${card.type} ending in ${card.last4}, ${card.exp_month}/${card.exp_year}`,
    inputType,
    checked
  );
}

const setupAccountPaymentForms = async (providerName, loadCards, loadBankAccounts, hostedFieldsToken) => {
  return {
    card: await setupNewCardForm(providerName, loadCards, hostedFieldsToken),
    // Stop-gap until we can support ACH tokenization
    bankAccount: providerName === 'GPI' ? await setupNewBankAccountForm(loadBankAccounts) : null
  };
}

const makePaymentMethodLoader = (inputType, rootSelector, ajaxCall, createElement) => {
  return function () {
    return sendAjax(ajaxCall)
      .then(items => {
        $(`${rootSelector}`).empty();
        // TODO: this seems hacky, why do I need to do this
        if (Array.isArray(items)) {
          $(rootSelector).append(items.map((card, i) => createElement(card, inputType, i === items.length - 1)));
        }
      });
  }
}

const makeCardLoader = inputType => makePaymentMethodLoader(inputType, '.credit-card-list', 'get_gpi_cards', createCreditCardElement);
const makeBankAccountLoader = inputType => makePaymentMethodLoader(inputType, '.bank-account-list', 'get_gpi_bank_accounts', createBankAccountElement);
const makeNoRefreshLoader = () => () => Promise.resolve();